import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const updateOptionOperation = async (
  pollId: number,
  questionId: number,
  optionId: number,
  optionText: string,
  setLoading: (isLoading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    if (optionText.length < 1) {
      toast.warn('על טקסט התשובה להכיל לפחות תו אחד');
      return;
    }
    setLoading(true);
    await appApi.updatePollQuestionOption(
      pollId,
      questionId,
      optionId,
      optionText,
    );
    await globalSettingsStores.fetchSetting();
    toast.success('התשובה עודכנה בהצלחה');
    setLoading(false);
    closeDialog();
  } catch (e) {
    toast.error('לא ניתן לבצע את הפעולה, נסה שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
